import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class ModuleGroupRoleUpdateError extends CodedError {
  static get errorName() {
    return errorCodes.moduleGroupRoleUpdateError.code;
  }

  constructor(message: string = errorCodes.moduleGroupRoleUpdateError.message) {
    super(message);
    this.code = errorCodes.moduleGroupRoleUpdateError.code;
    this.message = `${message} ${errorCodes.moduleGroupRoleUpdateError.code}`;
    this.name = errorCodes.moduleGroupRoleUpdateError.name;
    this.status = errorCodes.moduleGroupRoleUpdateError.status;
  }
}
